import { Modal } from 'antd'

const AppModal = ({
  open,
  setOpen,
  width = 500,
  icon,
  title,
  description,
  children,
}) => {
  return (
    <Modal
      width={width}
      title={null}
      open={open}
      onCancel={() => setOpen(false)}
      footer={null}
      centered
    >
      {icon && <div className='flex justify-center'>{icon}</div>}
      <div className='mb-32 mt-12'>
        {title && (
          <h3 className='text-xl font-semibold text-center'>{title}</h3>
        )}
        {description && (
          <p className='text-dimmed text-sm text-center mt-8'>{description}</p>
        )}
      </div>
      {children}
    </Modal>
  )
}

export default AppModal
